import unescapeHtmlTag from "../../../../../core/utils/tools";

const DescDisplayField = ({ description }) => {


  return (
    <div className={"detail-design-history-description"}>
      <span className={"label"}>Description</span>
      <div className={"value"}>
        { unescapeHtmlTag(description) }
      </div>
    </div>
  )
}

export default DescDisplayField;
